import {styled} from 'styled-components';
import {Toolbar} from '@mui/material';

const ToolbarStyle = styled(Toolbar)`
  margin: 0 !important;
  padding: 0 !important;
  min-height: inherit;
`;
export default ToolbarStyle;
